// initial state
const state = {
    list: null,
    current: null,
    currentIdx: -1,
    back: '',
    autoplay: false,
}

// getters
const getters = {
    current(state) {
        return state.current
    },
    isFirst(state) {
        if (!state.list || state.currentIdx === -1) {
            return true;
        }

        return state.currentIdx === 0
    },
    isLast() {
        if (!state.list || state.currentIdx === -1) {
            return true;
        }
        return state.currentIdx === state.list.length - 1
    },
    prevLink(state, getters) {
        if (!getters.isFirst) {
            let index = state.currentIdx
            return state.list[--index].link;
        }

        return null;
    },
    nextLink(state, getters) {
        if (!getters.isLast) {
            let index = state.currentIdx
            return state.list[++index].link;
        }

        return null;
    },
}

// actions
const actions = {
    clean({commit}) {
        commit('clean')
    },

    setBack({commit}, back) {
        commit('setBack', back)
    },
    setList({commit}, list) {
        commit('setList', list)
    },
    setCurrent({commit}, current) {
        commit('setCurrent', current)
    },
    goNext({state, commit}) {
        commit('setCurrent', state.list[state.currentIdx + 1])
    },
    goPrev({state, commit}) {
        commit('setCurrent', state.list[state.currentIdx - 1])
    },
    setAutoplay({commit}, value) {
        commit('setAutoplay', value)
    }
}

// mutations
const mutations = {
    clean(state) {
        state.back = null
        state.current = null
        state.currentIdx = -1
        state.list = null
    },

    setBack(state, back) {
        state.back = back
    },
    setList(state, list) {
        state.list = list
    },
    setCurrent(state, current) {
        state.current = current
        state.currentIdx = state.list.indexOf(state.current)
    },
    setAutoplay(state, value) {
        state.autoplay = value
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
